import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=24cec294&scoped=true&lang=pug&"
import script from "./Config.vue?vue&type=script&lang=js&"
export * from "./Config.vue?vue&type=script&lang=js&"
import style0 from "./Config.vue?vue&type=style&index=0&id=24cec294&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cec294",
  null
  
)

/* custom blocks */
import block0 from "@/lang/views/config.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fviews%2FConfig.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports